import { utilsModule } from "../utils-module";
import {showUserExchangeDialog} from '../../../redux/actions/users.actions';


utilsModule.controller('mainController', ['LoggedUserService', 'BackButton', 'appInfo',
    '$translate', '$state', 'dialogs', '$scope', 'LoginService', '$timeout','idhaApiError','LoadingBar',
    '$rootScope', 'OrderTypeService', 'themeProvider', 'clientService', '$mdMedia', 'serverAddress', '$window', '$ngRedux', function (LoggedUserService, BackButton, appInfo,
        $translate, $state, dialogs, $scope, LoginService, $timeout,idhaApiError,LoadingBar,
        $rootScope, OrderTypeService, themeProvider, clientService, $mdMedia, serverAddress, $window, $ngRedux) {

        var self = this;

        this.appName = appInfo.title;

        this.$mdMedia = $mdMedia;
        this.idhaApiError = idhaApiError;
        this.LoginService = LoginService;


        $rootScope.$on("auth_error", () => {
            console.log(`reagindo à auth_error em mainController`)
            LoginService.logout();
        })

        /**
         * Esta função realiza todo o processo de logout,
         * mas não redireciona o usuário para a tela de Login.
         * É utilizada pelo dialogo de troca de usuários, no qual só de
         * abrir o diálogo, os dados de acesso já são removidos
         */
        this.logoutInBackground = function(){
            LoginService.logout({stayInRoute:true});
        }

        this.exchangeUser = async function(email:string,password:string){
            try{
                LoadingBar.show()
                await LoginService.login(email,password,{goToState:'home'});
                $scope.$broadcast('refresh')
                await LoadingBar.hide();
            }catch(e){
                await LoadingBar.hide();
                if(e.data?.error?.code == 'LOGIN_FAILED'){
                    await dialogs.alert($translate.instant("INVALID_USER_PASSWORD"));
                }else{
                    await idhaApiError(e,'manager');
                }
                $ngRedux.dispatch(showUserExchangeDialog());
            }
        }

        this.onUserExchangeDialogClose = function(){
            dialogs.confirm($translate.instant('CONFIRM_LOGOFF'), $translate.instant('YES'), $translate.instant('NO')).then(async function () {
                LoginService.logout();
            },()=>{
                $ngRedux.dispatch(showUserExchangeDialog());
            });
        }


        this.loggedUser = LoggedUserService.getLoggedUser()
        this.showSearch = false;
        this.search = '';
        $scope.showSearch = this.showSearch;

        this.navList = undefined;
        this.selectedNav = undefined;

        $scope.$state = $state;

        this.userPhotoContainerUrl = `${serverAddress.managerURL}/ImagesContainer/user-photos`;

        this.tooltipDelay = function () {
            return $mdMedia('gt-sm') ? 0 : 1000;
        }

        this.getLoggedUser = function () {
            return LoggedUserService.getLoggedUser()
        };



        $scope.openMenu = function ($mdOpenMenu, event) {
            $timeout(function () {
                $mdOpenMenu(event);
            }, 300);
        };

        this.goBack = function () {
            BackButton.executeBackButtonCallbacks();
        };


        this.onLoginClick = function () {
            $state.go('login');
        }


        // BackButton.addGlobalCallback(function () {
        // if (self.isSearchBarShown()) {
        //     self.hideSearchBar();
        //     $scope.$digest();
        //     return true;
        // }
        // if (self.isOptionsBarShown()) {
        //     self.hideOptionsBar();
        //     $scope.$digest();
        //     return true;
        // }

        // });


        this.isLoginPage = function () {
            return ($state.current.name == "login");
        };

        this.isRoute = function (route: string) {
            return ($state.current.name == route);
        }

        this.showTopBar = function () {
            return !this.isLoginPage() && !this.isRoute('modules-menu')
        }

        this.showLeftBar = function () {
            return !this.isLoginPage() && ($state.current.name != "loginRegister");
        }

        this.isInHomePage = function () {
            //return ($state.current.name == currentOrderType.getStartRoute());
            return false;
        }

        this.isLogged = function () {
            var accessToken = window.localStorage.getItem('$LoopBack$accessTokenId');
            return (accessToken != undefined) && (accessToken != "");
        }


        this.init = function () {
            $ngRedux.connect(state => (
                {
                    page: state.page
                }
            ))(self)


        }
        this.init();



    }]);
